import { LogoutReason } from '@shared/constants';
import { UnauthorizedState } from '@shared/redux/reducers/auth-reducer';

export const initUnauthorizedState: UnauthorizedState = {
  isAuthenticated: false,
  lastLogoutReason: LogoutReason.Unknown,
};
